import { render, staticRenderFns } from "./HisroryItem.vue?vue&type=template&id=c3df4bc4&scoped=true&"
import script from "./HisroryItem.vue?vue&type=script&lang=ts&"
export * from "./HisroryItem.vue?vue&type=script&lang=ts&"
import style0 from "./HisroryItem.vue?vue&type=style&index=0&id=c3df4bc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3df4bc4",
  null
  
)

export default component.exports